import ApiClient from "Store/client";

export const fetchStudentsStatisticsApi = () => ApiClient<StudentStatistics>("api/students/stats");

export const addStudentToClassroomApi = (body) =>
  ApiClient<{ batch_id: string | null; total: number }>(`api/commands/add-student-to-class`, {
    method: "PATCH",
    body
  });

export const removeStudentFromClassroomApi = (body) =>
  ApiClient<{ batch_id: string | null; total: number }>(`api/commands/remove-student-from-class`, {
    method: "DELETE",
    body
  });

export const updateStudentCourseContextApi = (body) =>
  ApiClient(`api/commands/update-student-course-context`, {
    method: "PATCH",
    body
  });
export const fetchStudentsApi = (queryString) => ApiClient<Student[]>(`api/students${queryString}`);
export const fetchAllStudentsApi = (queryString) =>
  ApiClient<Partial<Student>[]>(`api/students/all${queryString}`);

export const fetchStudentApi = (studentId) => ApiClient<Student>(`api/students/${studentId}`);

export const createStudentApi = (postBody) =>
  ApiClient<string>("api/commands/create-student", { body: postBody, method: "POST" });

export const updateStudentCourseFlagsApi = (body) =>
  ApiClient(`api/commands/update-student-course-flags`, {
    method: "PATCH",
    body
  });

export const removeStudentFromLocationApi = (body) =>
  ApiClient(`api/commands/remove-student-from-location`, { body, method: "DELETE" });

export const fetchReportPreviewApi = (studentId) =>
  ApiClient<string>(`api/students/${studentId}/report`, { type: "text" });

export const assignInstructorToStudentApi = (body) =>
  ApiClient("api/commands/assign-instructor-to-student", { body, method: "POST" });

export const deleteStudentApi = (body) =>
  ApiClient(`api/commands/delete-student`, { method: "DELETE", body });

export const fetchStudentSessionsApi = (student_id) =>
  ApiClient(`api/students/${student_id}/sessions`);

export const updateStudentTargetScoreApi = (body) =>
  ApiClient(`api/commands/update-student-target-score`, {
    method: "PATCH",
    body
  });

export const updateStudentActivationApi = (body) =>
  ApiClient(`api/commands/update-student-activation`, {
    method: "PATCH",
    body,
    type: "text"
  });

export const updateStudentAddressApi = (body) =>
  ApiClient(`api/commands/update-student-address`, {
    method: "PATCH",
    body
  });

export const addStudentToLocationApi = (body) =>
  ApiClient(`api/commands/add-student-to-location`, {
    method: "PATCH",
    body
  });

export const handleUpdateStudentReportApi = (body) =>
  ApiClient(`api/commands/update-student-report`, {
    method: "PATCH",
    body
  });

export const handleSendReportApi = ({ body, studentId }) =>
  ApiClient(`api/students/${studentId}/report/send`, { method: "POST", body });

export const fetchStudentSummaryApi = (student_id) =>
  ApiClient(`api/students/${student_id}/summary`);

export const updateStudentApi = (body) =>
  ApiClient(`api/commands/update-student`, {
    method: "PATCH",
    body
  });

export const createStudentSessionApi = (body) =>
  ApiClient(`api/commands/create-student-session`, {
    method: "POST",
    body
  });

export const updateStudentSessionApi = (body) =>
  ApiClient(`api/commands/update-student-session`, {
    method: "PATCH",
    body
  });

export const unAssignInstructorFromStudentApi = (body) =>
  ApiClient(`api/commands/unassign-instructor-from-student`, {
    method: "DELETE",
    body
  });

export const deleteStudentSessionApi = (body) =>
  ApiClient(`api/commands/delete-student-session`, {
    method: "DELETE",
    body
  });

export const unEnrollStudentFromCourseApi = (body) =>
  ApiClient(`api/commands/unenroll-student-from-course`, {
    method: "DELETE",
    body
  });

export const enrollStudentInCourseApi = (body) =>
  ApiClient(`api/commands/enroll-student-in-course`, {
    method: "POST",
    body
  });

export const fetchAllCalendarWorksheetsApi = (student_id) =>
  ApiClient(`api/students/${student_id}/student_worksheets?simplified=1`);

export const updateStudentBaselineScoresApi = (body: StudentBaselineScoresRequest) =>
  ApiClient(`api/commands/update-student-baseline`, {
    method: "PATCH",
    body
  });

export const updateStudentArchivedApi = (body: UpdateStudentArchivedRequest) =>
  ApiClient(`api/commands/update-student-archived`, {
    method: "PATCH",
    body
  });

export const downloadStudentSyllabusApi = (studentId: string, body: DownloadStudentSyllabusApi) =>
  ApiClient(`api/students/${studentId}/sessions/csv`, {
    method: "POST",
    body,
    type: "text"
  });
